import { historyAPI, objectsApi as objectAPI, objectsApi, roomsApi, } from '../../API/API';
import {
  CLEAR_OBJECT,
  SET_CHANNEL_MANAGER_LIST,
  SET_HISTORY_LIST,
  SET_HISTORY_NAV_PARAMS,
  SET_OBJECT,
  SET_OBJECT_ID,
  SET_OBJECT_PAGE,
  SET_PRICES_TYPES_LIST,
  UPDATE_ROOM_LIST,
  UPDATE_STEP_BY_STEP,
} from './constans';
import { getObjectsList } from '../../components/Objects/actions';
import { updateSavingStatus } from '../app/actions';

export const setObject = (payload) => {
  return {
    type: SET_OBJECT,
    payload,
  };
};
export const setObjectPage = (pageName, payload) => {
  return {
    type: SET_OBJECT_PAGE,
    pageName,
    payload,
  };
};

export const updateRoomList = (payload) => {
  return {
    type: UPDATE_ROOM_LIST,
    payload,
  };
};

export const clearObject = () => {
  return {
    type: CLEAR_OBJECT,
  };
};

export const setObjectId = (payload) => {
  return {
    type: SET_OBJECT_ID,
    payload,
  };
};

export const setHistoryList = (payload) => {
  return {
    type: SET_HISTORY_LIST,
    payload,
  };
};

export const setHistoryNav = (payload) => {
  return {
    type: SET_HISTORY_NAV_PARAMS,
    payload,
  };
};

export const setChannelManangerList = (payload) => {
  return {
    type: SET_CHANNEL_MANAGER_LIST,
    payload,
  };
};

export const setPricesTypesList = (payload) => {
  return {
    type: SET_PRICES_TYPES_LIST,
    payload,
  };
};

export const updateStepByStep = (payload) => {
  return {
    type: UPDATE_STEP_BY_STEP,
    payload,
  };
};

export const getObjectById = (objectId) => async (dispatch) => {
  let response = await objectsApi.getById({ id: objectId });

  if (response.status) {
    dispatch(setObject(response.data));
  } else {
    return 'redirect';
  }
};

export const savePage = (data, blockLoader) => async (dispatch) => {
  dispatch(updateSavingStatus({ status: 'loading' }));
  let response = await objectsApi.update(data);

  if (response.status) {
    if (!blockLoader) dispatch(updateSavingStatus({ status: 'success' }));

    return dispatch(setObjectPage(data.section, response.data[data.section]));
  } else {
    dispatch(
      updateSavingStatus({ status: 'error', message: response.data.message })
    );
  }
};

export const setChannelManagerPage = (data) => async (dispatch) => {

  dispatch(updateSavingStatus({ status: 'loading' }));
  let response = await objectsApi.update(data);

  if (response.status) {
    dispatch(updateSavingStatus({ status: 'success' }));

    dispatch(clearObject());
    return dispatch(setObject({ channelManager: String(response.data.channelManager) }));
  } else {
    dispatch(
      updateSavingStatus({ status: 'error', message: response.data.message })
    );
  }
};

export const setStatusStepByStep = (status) => async (dispatch) => {
  dispatch(updateStepByStep(status));
};

// !
export const savePagePhotos = (formData, section) => async (dispatch) => {
  dispatch(updateSavingStatus({ status: 'loading' }));
  let response = await objectAPI.saveObjectPhotos(formData);
  if (response.status) {
    dispatch(updateSavingStatus({ status: 'success' }));
    return dispatch(setObjectPage(section, response.data[section]));
  } else {
    dispatch(
      updateSavingStatus({ status: 'error', message: response.data.message })
    );
  }
};

export const uploadPhoto = (formData, section) => async (dispatch) => {
  dispatch(updateSavingStatus({ status: 'loading' }));
  const response = await objectAPI.saveObjectPhotos(formData);
  if (!response.status) {
    dispatch(
      updateSavingStatus({ status: 'error', message: response.data.message })
    );
  }
  return response;
};

export const addObject = (object) => async (dispatch) => {
  dispatch(updateSavingStatus({ status: 'loading' }));
  let response = await objectsApi.addObject(object);

  if (response.status) {
    dispatch(updateSavingStatus({ status: '', message: '' }));
    dispatch(setObjectId(response.data.id));
    dispatch(getObjectsList());
  } else {
    dispatch(
      updateSavingStatus({ status: 'error', message: response.data.message })
    );
  }
};

export const getRoomsList = (object) => async (dispatch) => {
  let response = await roomsApi.getList(object);

  if (response.status) {
    dispatch(updateRoomList(response.data));
  }
};

export const getHistoryList = (params) => async (dispatch) => {
  let response = await historyAPI.getList(params);

  if (response.status) {
    dispatch(setHistoryList(response.data));
  }
};

export const getHistoryNav = (params) => async (dispatch) => {
  let response = await historyAPI.getHistoryNav(params);

  if (response.status) {
    dispatch(setHistoryNav(response.data));
  }
};

export const setHistoryListFromCache = (history) => async (dispatch) => {
  await dispatch(setHistoryList(history));
};

export const setHistoryNavFromCache = (navParams) => async (dispatch) => {
  await dispatch(setHistoryNav(navParams));
};

export const getChannelManagerList = () => async (dispatch) => {
  let response = await objectsApi.getChannelManagerList();

  if (response.data) {
    dispatch(setChannelManangerList(response.data));
  }
};

export const getPriceTypes = () => async (dispatch) => {
  let response = await roomsApi.getPriceTypes();

  if (response.status) {
    dispatch(setPricesTypesList(response.data));
  }
};
